import styled from "styled-components";

const Wrapper = styled.div`
    grid-area: content;
    width: 100%;
    height: 100%;
    background-color: var(--white);
`;

export default Wrapper;